import * as def from '@/definitions'
import { TextInfo } from '@/utilityModels/textInfo'
import { Layer } from './layer';
import { TextLayer } from './textLayer';
import { ArrayHelper } from '@/helper/arrayHelper';
import { StringHelper } from '@/helper/stringHelper';
import { FontManager } from '@/model/fontManager/fontManager';
import { ColorConstruct } from '@/utilityModels/colorConstruct';
import { MathHelper } from '@/helper/mathHelper';
import { Design } from '../design';
import { D3Helper } from '@/helper/d3Helper';
import { UnitHelper } from '@/helper/unitHelper';

// 3D文字レイヤー
export class D3TextLayer extends TextLayer
{
    public get layerType() : string { return "d3Text"; }
    
    // フォントID
    private _fontId : string = FontManager.DEFAULT_FONT_ID;
    public get fontId() { return this._fontId; }
    public set fontId(fontId) { this._fontId = fontId;}

    // 色
    private _textColor : ColorConstruct = new ColorConstruct(102, 51, 204);
    public get textColor() { return this._textColor; }
    public set textColor(textColor) { this._textColor = textColor; }

    // 厚み(%)
    private _thickness : number = 8;
    public get thickness() { return this._thickness; }
    public set thickness(thickness) { this._thickness = thickness; }

    // 回転(Y)
    private _rotateY : number = 0;
    public get rotateY() { return this._rotateY; }
    public set rotateY(rotateY) { this._rotateY = rotateY; }

    // 回転(X)
    private _rotateX : number = 0;
    public get rotateX() { return this._rotateX; }
    public set rotateX(rotateX) { this._rotateX = rotateX; }
    
    // 回転(Z)
    private _rotateZ : number = 0;
    public get rotateZ() { return this._rotateZ; }
    public set rotateZ(rotateZ) { this._rotateZ = rotateZ; }

    // ライト(Y)
    private _lightY : number = 0;
    public get lightY() { return this._lightY; }
    public set lightY(lightY) { this._lightY = lightY; }

    // ライト(X)
    private _lightX : number = 0;
    public get lightX() { return this._lightX; }
    public set lightX(lightX) { this._lightX = lightX; }

    // ライト(Z)
    private _lightZ : number = 0;
    public get lightZ() { return this._lightZ; }
    public set lightZ(lightZ) { this._lightZ = lightZ; }

    // 反射
    private _reflect : number = 64;
    public get reflect() { return this._reflect; }
    public set reflect(reflect) { this._reflect = reflect; }

    // 輝き
    private _brightness : number = 0;
    public get brightness() { return this._brightness; }
    public set brightness(brightness) { this._brightness = brightness; }

    // フォントjson文字列
    // 長すぎるので保存しない
    public fontJson : string = "";
    public fontJsonId : string = "";

    // 作成
    public static create(text : string, x : number, y : number, width : number, height : number) : D3TextLayer
    {
        var layer = new D3TextLayer();
        layer.text = text;
        
        layer.x = x;
        layer.y = y;
        layer.width = width;
        layer.height = height;
        
        return layer;
    }

    // 複製
    public clone()
    {
        var cloned = new D3TextLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : D3TextLayer)
    {
        layer.fontId = this._fontId;
        layer.textColor = this._textColor.clone();
        layer.thickness = this._thickness;
        layer.rotateY = this._rotateY;
        layer.rotateX = this._rotateX;
        layer.rotateZ = this._rotateZ;
        layer.lightY = this._lightY;
        layer.lightX = this._lightX;
        layer.lightZ = this._lightZ;
        layer.reflect = this._reflect;
        layer.brightness = this._brightness;

        super.cloneParameter(layer);
    }
    

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.fontId = this._fontId;
        jsonObject.textColor = this._textColor;
        jsonObject.thickness = this._thickness;
        jsonObject.rotateY = this._rotateY;
        jsonObject.rotateX = this._rotateX;
        jsonObject.rotateZ = this._rotateZ;
        jsonObject.lightY = this._lightY;
        jsonObject.lightX = this._lightX;
        jsonObject.lightZ = this._lightZ;
        jsonObject.reflect = this._reflect;
        jsonObject.brightness = this._brightness;

        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : D3TextLayer
    {
        var layer = new D3TextLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.fontId != null) { this._fontId = jsonData.fontId; }
        if(jsonData.textColor != null) { this._textColor = ColorConstruct.createFromJsonData(jsonData.textColor); }
        if(jsonData.thickness != null) { this._thickness = jsonData.thickness; }
        if(jsonData.rotateY != null) { this._rotateY = jsonData.rotateY; }
        if(jsonData.rotateX != null) { this._rotateX = jsonData.rotateX; }
        if(jsonData.rotateZ != null) { this._rotateZ = jsonData.rotateZ; }
        if(jsonData.lightY != null) { this._lightY = jsonData.lightY; }
        if(jsonData.lightX != null) { this._lightX = jsonData.lightX; }
        if(jsonData.lightZ != null) { this._lightZ = jsonData.lightZ; }
        if(jsonData.reflect != null) { this._reflect = jsonData.reflect; }
        if(jsonData.brightness != null) { this._brightness = jsonData.brightness; }

        super.loadParameterFromJson(jsonData);
    }
}